export const orderActionTypes = {
  FETCH_ORDER_DETAILS_START: 'FETCH_ORDER_DETAILS_START',
  FETCH_ORDER_DETAILS_SUCCESS: 'FETCH_ORDER_DETAILS_SUCCESS',
  FETCH_ORDER_DETAILS_FAILED: 'FETCH_ORDER_DETAILS_FAILED',
};
